import styled from "styled-components"

import tokens from "../_tokens"

const Image = styled.img`
  max-width: 100%;
  box-sizing: content-box;
  background-color: ${tokens.color.white};
`

export default Image
